var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.6095C14.266 4.76309 14.4869 4.984 14.6405 5.25003C14.7941 5.51605 14.875 5.81782 14.875 6.125V13.125C14.875 13.5891 14.6906 14.0342 14.3624 14.3624C14.0342 14.6906 13.5891 14.875 13.125 14.875H6.125C5.66087 14.875 5.21575 14.6906 4.88756 14.3624C4.55937 14.0342 4.375 13.5891 4.375 13.125V6.125C4.375 5.66087 4.55937 5.21575 4.88756 4.88756C5.21575 4.55937 5.66087 4.375 6.125 4.375H8.75",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 11.1423C1.48372 10.9885 1.26264 10.7673 1.10903 10.501C0.95542 10.2346 0.874701 9.93248 0.875001 9.625V2.625C0.875001 2.16087 1.05938 1.71575 1.38756 1.38756C1.71575 1.05937 2.16087 0.875 2.625 0.875H9.625C10.0891 0.875 10.5342 1.05937 10.8624 1.38756C11.1906 1.71575 11.375 2.16087 11.375 2.625V9.625C11.375 10.0891 11.1906 10.5342 10.8624 10.8624C10.5342 11.1906 10.0891 11.375 9.625 11.375H7",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnified);
export default __webpack_public_path__ + "static/media/unified.3970c1eacbc4c935d60eaabc1cdf2b0f.svg";
export { ForwardRef as ReactComponent };